import { Inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import
{
    ExecutionResult,
    ILegacyLookupService,
    IPurchaseOrderLookup,
    LookupCriteria,
} from "@tylertech/tyler-api-types";

@Injectable()
export class ReqAndPoLookupService implements ILegacyLookupService<IPurchaseOrderLookup>
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    Lookup(criteria: LookupCriteria): Promise<ExecutionResult<IPurchaseOrderLookup[]>>
    {
        return this.$apiService.sendAuth("IReqAndPoLookupService/Lookup", criteria);
    }
}
